<template>
  <div class="download-container">
    <div class="container">
      <!-- 页面头部 -->


      <!-- 搜索和筛选区域 -->
<!--      <div class="filter-section">-->
<!--        <div class="search-box">-->
<!--          <input -->
<!--            type="text" -->
<!--            v-model="searchKeyword" -->
<!--            placeholder="搜索文件名称..." -->
<!--            class="search-input"-->
<!--            @input="filterFiles"-->
<!--          />-->
<!--          <span class="search-icon">🔍</span>-->
<!--        </div>-->
<!--        -->
<!--        <div class="category-tabs">-->
<!--          <button -->
<!--            v-for="category in categories" -->
<!--            :key="category.value"-->
<!--            :class="['category-tab', { active: activeCategory === category.value }]"-->
<!--            @click="selectCategory(category.value)"-->
<!--          >-->
<!--            <span class="category-icon">{{ category.icon }}</span>-->
<!--            <span class="category-name">{{ category.name }}</span>-->
<!--          </button>-->
<!--        </div>-->
<!--      </div>-->

      <!-- 文件列表 -->
      <div class="files-section">
        <div class="files-header">
          <h2>文件列表</h2>
          <span class="file-count">共 {{ filteredFiles.length }} 个文件</span>
        </div>

        <div class="files-grid" v-if="filteredFiles.length > 0">
          <div 
            v-for="file in filteredFiles" 
            :key="file.id"
            class="file-card"
          >
            <div class="file-info">
              <h3 class="file-name" :title="file.name">{{ file.name }}</h3>
              <div class="file-meta">
                <span class="file-size">{{ formatFileSize(file.size) }}</span>
              </div>
              <div class="file-desc" v-if="file.description">{{ file.description }}</div>
              <div class="file-date">更新于 {{ formatDate(file.updateDate) }}</div>
            </div>
            <div class="file-actions">
              <button 
                class="download-btn"
                @click="downloadFile(file)"
                :disabled="file.downloading"
              >
                <span v-if="!file.downloading">下载</span>
                <span v-else>下载中...</span>
              </button>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="empty-state" v-else>
          <div class="empty-icon">📭</div>
          <p class="empty-text">暂无文件</p>
          <p class="empty-desc">请尝试更换搜索关键词或选择其他分类</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

// 搜索关键词
const searchKeyword = ref('')
// 当前选中的分类
const activeCategory = ref('all')

// 分类列表
const categories = ref([
  { value: 'all', name: '全部', icon: '📦' },
  { value: 'software', name: '软件', icon: '💻' },
  { value: 'document', name: '文档', icon: '📄' },
  { value: 'image', name: '图片', icon: '🖼️' },
  { value: 'video', name: '视频', icon: '🎬' },
  { value: 'other', name: '其他', icon: '📎' }
])

// 文件列表（示例数据，实际应该从API获取）
const files = ref([
  {
    id: 1,
    name: 'CP500_DRIVER_1.35安装包',
    size: 48105378,
    description: 'CP500软件安装',
    updateDate: '2026-01-15',
    url: 'https://wiseagent.oss-cn-shanghai.aliyuncs.com/website/CP500_DRIVER_1.35.rar',
    downloading: false
  },
  {
    id: 1,
    name: 'CP500模版文件',
    size: 69471322,
    description: 'CP500模版文件',
    updateDate: '2026-01-24',
    url: 'https://wiseagent.oss-cn-shanghai.aliyuncs.com/website/upload/2026/CP500%E6%A8%A1%E7%89%88%E6%96%87%E4%BB%B6.zip',
    downloading: false
  },
])

// 筛选后的文件列表
const filteredFiles = computed(() => {
  let result = files.value

  // 按分类筛选
  if (activeCategory.value !== 'all') {
    result = result.filter(file => file.type === activeCategory.value)
  }

  // 按关键词搜索
  if (searchKeyword.value.trim()) {
    const keyword = searchKeyword.value.toLowerCase()
    result = result.filter(file => 
      file.name.toLowerCase().includes(keyword) ||
      (file.description && file.description.toLowerCase().includes(keyword))
    )
  }

  return result
})

// 选择分类
const selectCategory = (category) => {
  activeCategory.value = category
}

// 筛选文件
const filterFiles = () => {
  // 计算属性会自动更新，这里可以添加其他逻辑
}

// 获取文件图标
const getFileIcon = (type) => {
  const iconMap = {
    software: '💻',
    document: '📄',
    image: '🖼️',
    video: '🎬',
    other: '📎'
  }
  return iconMap[type] || '📎'
}

// 格式化文件大小
const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
}

// 格式化日期
const formatDate = (dateString) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

// 下载文件
const downloadFile = async (file) => {
  if (file.downloading) return

  try {
    file.downloading = true
    
    // 创建下载链接
    const link = document.createElement('a')
    link.href = file.url
    link.download = file.name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // 模拟下载延迟（实际项目中可以监听下载完成事件）
    setTimeout(() => {
      file.downloading = false
    }, 1000)
  } catch (error) {
    console.error('下载失败:', error)
    file.downloading = false
    alert('下载失败，请稍后重试')
  }
}

onMounted(() => {
  // 可以在这里从API加载文件列表
  // loadFiles()
})
</script>

<style scoped>
.download-container {
  min-height: 100vh;
  background: #f5f6fa;
  padding-top: 1rem;
  padding-bottom: 3rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页面头部 */
.header {
  text-align: center;
  margin-bottom: 40px;
}

.header h1 {
  font-size: 2.5em;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.header p {
  font-size: 1.1em;
  color: #666;
}

/* 筛选区域 */
.filter-section {
  background: white;
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.search-box {
  position: relative;
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
  padding: 12px 45px 12px 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1em;
  transition: all 0.3s;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.search-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2em;
  pointer-events: none;
}

.category-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.category-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.95em;
}

.category-tab:hover {
  border-color: #667eea;
  background: #f0f4ff;
}

.category-tab.active {
  border-color: #667eea;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.category-icon {
  font-size: 1.2em;
}

/* 文件列表区域 */
.files-section {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.files-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.files-header h2 {
  font-size: 1.8em;
  color: #333;
}

.file-count {
  color: #666;
  font-size: 0.95em;
}

.files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.file-card {
  border: 2px solid #f0f0f0;
  border-radius: 12px;
  padding: 20px;
  background: #fafafa;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
}

.file-card:hover {
  border-color: #667eea;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
  transform: translateY(-2px);
}

.file-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  margin-bottom: 15px;
}

.file-info {
  flex: 1;
  margin-bottom: 15px;
}

.file-name {
  font-size: 1.1em;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-meta {
  display: flex;
  gap: 15px;
  margin-bottom: 8px;
  font-size: 0.9em;
}

.file-size {
  color: #666;
}

.file-type {
  color: #667eea;
  background: #f0f4ff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.85em;
}

.file-desc {
  color: #888;
  font-size: 0.9em;
  margin-bottom: 8px;
  line-height: 1.4;
}

.file-date {
  color: #999;
  font-size: 0.85em;
}

.file-actions {
  margin-top: auto;
}

.download-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}

.download-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.download-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 4em;
  margin-bottom: 20px;
}

.empty-text {
  font-size: 1.5em;
  color: #333;
  margin-bottom: 10px;
}

.empty-desc {
  color: #666;
  font-size: 1em;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .download-container {
    padding-top: 8rem;
  }

  .header h1 {
    font-size: 2em;
  }

  .files-grid {
    grid-template-columns: 1fr;
  }

  .category-tabs {
    justify-content: center;
  }

  .files-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>